import { render, staticRenderFns } from "./AddressDisplay.vue?vue&type=template&id=4687b135"
import script from "./AddressDisplay.vue?vue&type=script&lang=js"
export * from "./AddressDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports